import bmw from "./bmw.svg";
import bosch from "./bosch.svg";
import certifica from "./certifica-img.svg";
import detailBtnIcon from "./detail-btn-icon.svg";
import fca from "./fca.svg";
import hella from "./hella.svg";
import kiwa from "./kiwa.svg";
import logo from "./logo.svg";
import manIcon from "./man.svg";
import nsf from "./nsf.svg";
import porsche from "./porsche.svg";
import scania from "./scania.svg";
import sendIcon from "./send-icon.svg";
import tickBoxIcon from "./tick-box-icon.svg";
import ul from "./ul.svg";
import volkswagen from "./vw.svg";
import wras from "./wras.svg";
import logoWhite from "./logo-white.svg";
import gallery1 from "./gallery-img-1.jpg";
import gallery2 from "./gallery-img-2.JPG";
import gallery3 from "./gallery-img-3.jpg";
import gallery4 from "./gallery-img-4.JPG";
import historyImg from "./history-img.svg";
import productHeader from "./product-header-img.svg";
import producProm from "./product-promotion.svg";
import contactHeaderImg from "./contact-header-img.svg";
import historyMobile from "./history-mobile.svg";
import producPromMobile from "./product-prom-mobile.svg";
import navPruductİcon from "./nav-pruducts-icon.svg";
import packetOne from "./packet-one.svg";
import packetTwo from "./packet-two.svg";
import packetThree from "./packet-three.svg";
import packetFour from "./packet-four.svg";
import packetFive from "./packet-five.svg";
import qualityControl from "./quality-control-header-bottom.svg";
import qualityAssurance from "./quality-assurance-header-bottom.svg";
import qualityIsoIcon from "./quality-iso-icon.svg";

const images = {
  bmw,
  bosch,
  certifica,
  detailBtnIcon,
  fca,
  hella,
  kiwa,
  logo,
  manIcon,
  nsf,
  porsche,
  scania,
  sendIcon,
  tickBoxIcon,
  ul,
  volkswagen,
  wras,
  logoWhite,
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  historyImg,
  productHeader,
  producProm,
  contactHeaderImg,
  historyMobile,
  producPromMobile,
  navPruductİcon,
  packetOne,
  packetTwo,
  packetThree,
  packetFour,
  packetFive,
  qualityControl,
  qualityAssurance,
  qualityIsoIcon,
};

export default images;
